module.exports = __webpack_public_path__ + "static/media/icbc.35702af8.png";